export default __webpack_public_path__ + "static/bookcover-ro-9a02e607e216c16b260244df10247318.png";